module.exports = __webpack_public_path__ + "static/media/Screenshot_2025-12-18_at_18.47.35-removebg-preview.98a5561e.png";